(function() {
  angular
    .module('specsguardApp')
    .controller('widgetProjectDocumentsCtrl', widgetProjectDocumentsCtrl);

  widgetProjectDocumentsCtrl.$inject = ['Labels', '$scope', '$window', '$filter', '$state', 'sg2AuthService'];

  function widgetProjectDocumentsCtrl (Labels, $scope, $window, $filter, $state, sg2AuthService) {
    const vm = this;
    vm.LABELS = Labels;
    vm.downloadableDocs = [];

    vm.$onInit = function () {
      updateProject($scope.project);
      vm.downloadableDocs = sortOnDate(vm.downloadableDocs);

      vm.canCreatePdf = sg2AuthService.canCreate('pdf');
    };

    const updateProject = (updatedProject: any) => {
      vm.project = updatedProject;
      fetchDocuments(vm.project.downloadableDocuments);
    };

    vm.downloadDoc = (documentPath) => {
      $window.open(documentPath, '_blank');
    };

    vm.goToDocuments = () => {
      $state.go('project/documents');
    };

    function setDocPathsAndMb (docs) {
      return docs.map((doc) => {
        doc.uriEncodedPath = encodeURI(doc.path);
        doc.dateString = $filter('sgDateAgo')(new Date(doc.date));
        doc.sizeMb = Number(doc.size / 1024 / 1024).toFixed(2);
        return doc;
      });
    }

    function fetchDocuments (docs) {
      docs.forEach((doc) => {
        Object.assign(doc, doc.file); // Contains the actual type, size of an file
        doc.status = true;
        vm.downloadableDocs.push(doc);
      });

      vm.downloadableDocs = sortOnDate(setDocPathsAndMb(vm.downloadableDocs));
    }

    function sortOnDate (docsObject) {
      return docsObject.sort( (a, b) => {
        if (a.date > b.date) {
          return -1;
        }

        return 1;
      });
    }
  }

})();
